@if (label(); as label) {
  <elcia-label [label]="label"/>
}
<p-toggle-switch [formControl]="control()"/>
